<div class="fd-popup-template">
    <h2 mat-dialog-title [class]="data.warn ? 'warning-popup':''">{{data.title}}</h2>
    <mat-dialog-content>
      <span [innerHTML]="data.content"></span>
    </mat-dialog-content>
    <mat-dialog-actions align="center">
      <button mat-button (click)="okayClick()" >{{data.okayBtnText? data.okayBtnText : 'Close'}}</button>
      @if(data.cancelBtnText){
        <button mat-button (click)="cancelClick()" cdkFocusInitial>{{data.cancelBtnText}}</button>
      }
    </mat-dialog-actions>
</div>